import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { Source } from 'types/GlobalSource'

// select current customer
export const selectActiveSource = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.SourceStore.data,
    (_: ApplicationState, activeSourceId: string) => activeSourceId
  ],
  (data, activeSourceId) => {
    const sources = Object.values(data)

    for (let i = 0; i < sources.length; i++) {
      if (sources[i].included && sources[i].included.active_sources) {
        const activeSource = sources[i].included.active_sources.find(
          (item) => item.id === activeSourceId
        )

        if (activeSource) {
          return { source: sources[i], activeSource }
        }
      }
    }

    return { source: null, activeSource: null }
  }
)

export const selectSources = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.SourceStore
  ],
  (
    store
  ): [
    boolean,
    {
      [key: string]: Source
    }
  ] => [store.fetched, store.data]
)
